// extracted by mini-css-extract-plugin
export var card = "_av-1";
export var container = "_av-0";